import { bindRequestLogic } from './utils'
import ShowcaseContactLogTypes from '../actionTypes/showcaseContactLogs'
import { showcaseContactLogAPI } from '../api'

const getContactLogs = bindRequestLogic({
  clientFunc: showcaseContactLogAPI.getShowcaseContactLogs,
  type: ShowcaseContactLogTypes.GET_SHOWCASE_LOGS_REQUEST,
  successType: ShowcaseContactLogTypes.GET_SHOWCASE_LOGS_SUCCESS,
  failType: ShowcaseContactLogTypes.GET_SHOWCASE_LOGS_FAILED,
  isQueryParam: true
})

const exportShowcaseContactLogs = bindRequestLogic({
  clientFunc: showcaseContactLogAPI.exportShowcaseContactLogs,
  type: ShowcaseContactLogTypes.EXPORT_SHOWCASE_CONTACT_LOG_REQUEST,
  successType: ShowcaseContactLogTypes.EXPORT_SHOWCASE_CONTACT_LOG_SUCCESS,
  failType: ShowcaseContactLogTypes.EXPORT_SHOWCASE_CONTACT_LOG_FAILED,
  isQueryParam: true
})

const updateAnonymizeVisitor = bindRequestLogic({
  clientFunc: showcaseContactLogAPI.updateAnonymizeVisitor,
  type: ShowcaseContactLogTypes.UPDATE_ANONYMIZE_VISITOR_REQUEST,
  successType: ShowcaseContactLogTypes.UPDATE_ANONYMIZE_VISITOR_SUCCESS,
  failType: ShowcaseContactLogTypes.UPDATE_ANONYMIZE_VISITOR_FAILED,
  isQueryParam: false
})

export default [
  getContactLogs,
  exportShowcaseContactLogs,
  updateAnonymizeVisitor
]
